import { classesBuilder } from '@common/helpers';

import type { ISafeProps } from './types';

import style from '../styles.module.scss';

const Safe = ({ isAnimated = false, isLoggingIn = false }: ISafeProps) => {
  return (
    <div className={classesBuilder(style['safe-wrapper'], { [style['animate-zoom']]: isAnimated })}>
      <div className={classesBuilder(style.safe, { [style['animate-door']]: isAnimated })}>
        <div
          className={classesBuilder(style.gate, {
            [style['animate-safe-open']]: isAnimated,
            [style['delayed-spin']]: isLoggingIn && isAnimated,
            [style['rotate-loading']]: isLoggingIn && !isAnimated,
          })}
        />
      </div>
    </div>
  );
};

export default Safe;
